module.exports = __webpack_public_path__ + "static/media/avatar.bd328fd2.png";